export const CHECKOUT_EXTENSION_PATH = "/index.html";
export const CHECKOUT_REFRESH_PROTOCOL = "redo:bigcommerce-checkout:v1";

export function isRefreshMessage(
  data: unknown,
): data is {
  protocol: typeof CHECKOUT_REFRESH_PROTOCOL;
  type: "refresh" | "dispatched";
  requestId: string;
} {
  if (typeof data !== "object" || data === null) {
    return false;
  }
  return (
    "protocol" in data &&
    data.protocol === CHECKOUT_REFRESH_PROTOCOL &&
    "requestId" in data &&
    typeof data.requestId === "string" &&
    "type" in data &&
    (data.type === "refresh" || data.type === "dispatched")
  );
}
